'use client';

import React from 'react';
import { cn } from '../lib/utils';
import { PageHeader, type PageHeaderProps } from './page-header';
import { StateKit, type StateKitProps } from './state-kit';
import { SubPageTabs, type SubPageTabsProps } from './sub-page-tabs/sub-page-tabs';

export interface RecordWorkspaceProps {
  header: PageHeaderProps;
  tabs?: SubPageTabsProps;
  state?: StateKitProps;
  children: React.ReactNode;
  className?: string;
}

/** Identity header, one record navigation bar and the selected content or state. */
export function RecordWorkspace({
  header,
  tabs,
  state,
  children,
  className,
}: RecordWorkspaceProps) {
  return (
    <div className={cn('min-w-0 space-y-6', className)}>
      <PageHeader {...header} />
      {tabs && <SubPageTabs {...tabs} />}
      {state ? <StateKit {...state} /> : children}
    </div>
  );
}
